import { type Meta } from '../types/docs';
import { SKILL_ANALYTICS_SCOPES, SKILL_ANALYTICS_TYPES } from './skillAnalytics';

const META: Meta = {
  description: 'Fired when a user successfully creates a new skill',
  name: 'skill_created',
  params: [
    {
      description: 'ID of the created skill',
      name: 'skill_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Whether the skill was published to workspace immediately',
      name: 'scope',
      required: true,
      type: 'enum',
      values: [...SKILL_ANALYTICS_SCOPES],
    },
    {
      description: 'Which skill surface was created',
      name: 'type',
      required: true,
      type: 'enum',
      values: [...SKILL_ANALYTICS_TYPES],
    },
  ],
};

export default META;
